import React, { useState } from 'react';
import api from '../api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post('auth/forgot-password', { email });
      setMessage(res.data.message);
    } catch (error) {
      console.error('Error forgot password:', error);
      setMessage(error.response?.data?.message || 'Error requesting reset');
    }
  };

  return (
    <div className="container mt-5">
      <h2>Forgot Password</h2>
      {message && <div className="alert alert-info">{message}</div>}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Enter your email</label>
          <input 
            type="email"
            className="form-control"
            value={email}
            onChange={(e)=> setEmail(e.target.value)}
            required
          />
        </div>
        <button className="btn btn-primary" type="submit">Send reset link</button>
      </form>
    </div>
  );
};

export default ForgotPassword;
